import { create } from "zustand";

type ToasterPosition =
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right"
  | "top-center"
  | "bottom-center";

interface UiStore {
  toasterPosition: ToasterPosition;
  setToasterPosition: (pos: ToasterPosition) => void;
}

export const useUiStore = create<UiStore>((set) => ({
  toasterPosition: "top-right",
  setToasterPosition: (pos) => set({ toasterPosition: pos }),
}));
